import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

interface TypeWriterProps {
    text: string;
    delay?: number;
    speed?: number;
    className?: string;
    cursor?: boolean;
    onComplete?: () => void;
}

const TypeWriter: React.FC<TypeWriterProps> = ({
                                                   text,
                                                   delay = 0,
                                                   speed = 50,
                                                   className = '',
                                                   cursor = true,
                                                   onComplete,
                                               }) => {
    const [displayedText, setDisplayedText] = useState('');
    const [isTyping, setIsTyping] = useState(false);
    const [showCursor, setShowCursor] = useState(cursor);

    useEffect(() => {
        let timeout: NodeJS.Timeout;
        let currentIndex = 0;

        const startTyping = () => {
            setIsTyping(true);

            const typeNextChar = () => {
                if (currentIndex < text.length) {
                    setDisplayedText(text.slice(0, currentIndex + 1));
                    currentIndex++;
                    timeout = setTimeout(typeNextChar, speed);
                } else {
                    setIsTyping(false);
                    if (onComplete) onComplete();
                    setTimeout(() => setShowCursor(false), 1000);
                }
            };

            timeout = setTimeout(typeNextChar, delay);
        };

        startTyping();

        return () => {
            clearTimeout(timeout);
        };
    }, [text, delay, speed, onComplete]);

    return (
        <span className={`inline-block ${className}`}>
      {displayedText}
            {cursor && showCursor && (
                <motion.span
                    className="inline-block w-0.5 h-full bg-current ml-1"
                    animate={{ opacity: [1, 0, 1] }}
                    transition={{ duration: 1, repeat: Infinity }}
                />
            )}
    </span>
    );
};

export default TypeWriter;